import * as React from "react";

import { Card } from "@/components/ui/primitives";
import { cn } from "@/lib/utils";

export function PageHeader({
  title,
  description,
  actions,
}: {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-foreground">{title}</h1>
        {description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}

export function StatTile({
  label,
  value,
  hint,
  accent,
}: {
  label: string;
  value: React.ReactNode;
  hint?: string;
  accent?: "primary" | "success" | "warning" | "destructive" | "muted";
}) {
  const bar =
    accent === "success"
      ? "bg-[hsl(var(--success))]"
      : accent === "warning"
        ? "bg-[hsl(var(--warning))]"
        : accent === "destructive"
          ? "bg-destructive"
          : accent === "muted"
            ? "bg-muted-foreground/40"
            : "bg-accent";
  return (
    <Card className="relative overflow-hidden p-5">
      <span className={cn("absolute left-0 top-0 h-full w-1", bar)} />
      <div className="pl-2">
        <div className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
          {label}
        </div>
        <div className="mt-1 text-3xl font-bold tabular-nums text-foreground">{value}</div>
        {hint ? <div className="mt-1 text-xs text-muted-foreground">{hint}</div> : null}
      </div>
    </Card>
  );
}
